export const INSTITUTE_TYPE = Object.freeze({
  HIGHER_EDUCATION: { id: 1, name: "Higher Education", alias: 'UNI'},
  EMPLOYMENT: { id: 3, name: "Employment History", alias: 'EMPLOYMENT'},
  PROF_BODY: { id: 5, name: "Professional Body", alias: 'PROF_BODY' },
  PROF_LIC: { id: 7, name: "Professional License", alias: 'PROF_LIC' },
  PROF_CERT: { id: 9, name: "Professional Certificate", alias: 'PROF_CERT' },
  HIGH_SCHOOL: { id: 11, name: "High School", alias: 'HIGH_SCHOOL' },
  IDENTITY: { id: 13, name: "Identity Document", alias: 'IDENTITY' },
  ENG_LANG: { id: 15, name: "SELT Validation", alias: 'ENG_LANG' },
  ACA_REF: { id: 17, name: "Academic Reference", alias: 'ACA_REF' }
});

export const getTypeById = (id) => {
  for (const key in INSTITUTE_TYPE) {
    if(INSTITUTE_TYPE[key].id === id) {
      return INSTITUTE_TYPE[key].name
    }
  }
}

export const getNameByAlias = (alias) => {
  for (const key in INSTITUTE_TYPE) {
    if (INSTITUTE_TYPE[key].alias === alias) {
      return INSTITUTE_TYPE[key].name
    }
  }
}
